/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {RouteTwoPanelBottomLayoutComponent} from '../common/directives/route-two-panel-layout.component';
import {PERMISSIONS} from "../../components/auth/auth-constants";
import {ProductFeedApiService} from '../common/controller/product-feed-api.service';
import {RetailProductListPageComponent} from './retail-product-list-page.component';
import {emptyRouteView} from '../common/directives/html/route-view-components';



export function retailProductStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
let rh = adnRouterHelper.createRouterAndChildHelper('retail-products.retail-product', ProductFeedApiService, '', 'app.adv', 'app');
        states.add(rh.listPath(), rh.list({
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasAny(PERMISSIONS.manageAdvertising.apiKey);
            },
            showConversionTracking: () => true
          },
          views: {
            'content@app': {
              component: RetailProductListPageComponent,
              bindings: {readOnly: 'listReadOnly', showConversionTracking: 'showConversionTracking'}
            }
          }
        }))
          .add(rh.newItemPath(), rh.newItem())
          .add(rh.itemPath(), rh.item({
            resolve: {
              showConversionTracking: () => true
            },
            views: {
              'content@app': {
                component: RouteTwoPanelBottomLayoutComponent
              },
              'context@app': emptyRouteView()
            }
          }, 'RetailProduct'));
  return states.build();
}
